// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ud-page .dashboard-body {
  padding-bottom: 2rem;
}

.ud-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}

.ud-mode-tabs {
  display: flex;
  gap: 0.6rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.ud-mode-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #334155;
  border-radius: 999px;
  padding: 0.55rem 1rem;
  font-size: 0.9rem;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
}

.ud-mode-tab--active {
  color: #fff;
  border-color: #0f766e;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
}

.ud-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.ud-stat {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.95rem 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.ud-stat span {
  display: block;
  font-size: 0.78rem;
  color: #64748b;
  margin-bottom: 0.3rem;
}

.ud-stat strong {
  font-size: 1.35rem;
  color: #0f172a;
}

.ud-charts {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.ud-chart-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.ud-chart-card h3 {
  margin: 0 0 0.75rem;
  font-size: 0.88rem;
  color: #0f172a;
}

.ud-chart-card__body {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex-wrap: wrap;
}

.ud-donut {
  position: relative;
  width: 168px;
  height: 168px;
  flex-shrink: 0;
}

.ud-donut__center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.ud-donut__center strong {
  font-size: 0.95rem;
  color: #0f172a;
}

.ud-donut__center span {
  font-size: 0.7rem;
  color: #64748b;
}

.ud-legend {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: 0.78rem;
  color: #475569;
}

.ud-legend li {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.ud-legend span {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  flex-shrink: 0;
}

.ud-legend strong {
  margin-left: auto;
  color: #0f172a;
}

.ud-bars {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.ud-bar-row {
  display: grid;
  grid-template-columns: 88px 1fr 72px;
  gap: 0.5rem;
  align-items: center;
  font-size: 0.78rem;
}

.ud-bar-row__label {
  color: #475569;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ud-bar-row__track {
  height: 10px;
  background: #f1f5f9;
  border-radius: 999px;
  overflow: hidden;
}

.ud-bar-row__fill {
  height: 100%;
  border-radius: 999px;
  min-width: 0;
}

.ud-bar-row__value {
  text-align: right;
  font-weight: 700;
  color: #0f172a;
}

.ud-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.ud-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  align-items: flex-end;
  margin-bottom: 0.9rem;
}

.ud-toolbar form {
  display: flex;
  gap: 0.45rem;
  flex: 1 1 280px;
}

.ud-toolbar input,
.ud-toolbar select {
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  padding: 0.45rem 0.65rem;
  font-size: 0.86rem;
  font-family: inherit;
}

.ud-toolbar form input {
  flex: 1 1;
  min-width: 180px;
}

.ud-toolbar label {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.72rem;
  font-weight: 700;
  color: #64748b;
}

.ud-toolbar form button,
.ud-btn-view {
  border: none;
  border-radius: 8px;
  padding: 0.45rem 0.8rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  cursor: pointer;
  font-family: inherit;
}

.ud-export {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: none;
  border-radius: 8px;
  padding: 0.45rem 0.85rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #15803d 0%, #22c55e 100%);
  cursor: pointer;
  font-family: inherit;
}

.ud-export:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.ud-toast {
  margin: 0 0 0.75rem;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  font-size: 0.85rem;
}

.ud-toast--success {
  color: #166534;
  background: rgba(22, 101, 52, 0.1);
}

.ud-toast--error {
  color: #b91c1c;
  background: rgba(220, 38, 38, 0.08);
}

.ud-empty {
  text-align: center;
  color: #64748b;
  padding: 1.5rem 0.6rem;
}

.ud-empty i {
  display: block;
  font-size: 1.5rem;
  margin-bottom: 0.45rem;
}

.ud-table-wrap {
  overflow-x: auto;
}

.ud-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.ud-table th {
  padding: 0.7rem 0.75rem;
  text-align: left;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #f8fafc;
  background: #0f172a;
  white-space: nowrap;
}

.ud-table td {
  padding: 0.7rem 0.75rem;
  border-bottom: 1px solid #e2e8f0;
  color: #1e293b;
  vertical-align: top;
}

.ud-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.ud-user-mini {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.ud-user-mini strong {
  color: #0f172a;
}

.ud-user-mini span {
  font-size: 0.75rem;
  color: #64748b;
}

.ud-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.12rem 0.48rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
}

.ud-chip--ok {
  background: rgba(13, 148, 136, 0.14);
  color: #0f766e;
}

.ud-chip--pending {
  background: rgba(217, 119, 6, 0.14);
  color: #b45309;
}

.ud-chip--bad {
  background: rgba(220, 38, 38, 0.12);
  color: #b91c1c;
}

.ud-chip--muted {
  background: #f1f5f9;
  color: #64748b;
}

.ud-chip--level {
  background: rgba(15, 118, 110, 0.12);
  color: #0f766e;
}

.ud-pagination {
  margin-top: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  font-size: 0.85rem;
  color: #64748b;
}

.ud-pagination label {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.72rem;
  font-weight: 700;
}

.ud-pagination select,
.ud-pagination button {
  border: 1px solid #dbe2ea;
  background: #fff;
  border-radius: 8px;
  padding: 0.35rem 0.65rem;
  font-family: inherit;
  cursor: pointer;
}

.ud-pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ud-pagination div {
  display: flex;
  gap: 0.4rem;
}

.ud-detail-head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.7rem;
  margin-bottom: 0.85rem;
}

.ud-detail-head h2 {
  margin: 0;
  font-size: 1.15rem;
  color: #0f172a;
}

.ud-detail-head p {
  margin: 0.2rem 0 0;
  color: #64748b;
  font-size: 0.85rem;
}

.ud-btn-back {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #0f172a;
  border-radius: 8px;
  padding: 0.4rem 0.75rem;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.ud-detail-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  align-items: center;
  margin-bottom: 0.85rem;
  font-size: 0.85rem;
  color: #475569;
}

.ud-help {
  margin: 0 0 1rem;
  padding: 0.65rem 0.8rem;
  background: #f0fdfa;
  border: 1px solid #99f6e4;
  border-radius: 10px;
  color: #0f766e;
  font-size: 0.85rem;
}

.ud-stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.7rem;
  margin-top: 0.25rem;
}

.ud-stat-grid div {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.7rem 0.8rem;
}

.ud-stat-grid span,
.ud-stat-grid small {
  display: block;
  color: #64748b;
  font-size: 0.72rem;
}

.ud-stat-grid strong {
  display: block;
  margin: 0.2rem 0;
  font-size: 1.05rem;
  color: #0f172a;
}

.ud-block-title {
  margin: 1.1rem 0 0.65rem;
  font-size: 0.92rem;
  color: #0f172a;
}

.ud-chain {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0.45rem;
}

.ud-chain-node {
  min-width: 140px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.65rem 0.75rem;
}

.ud-chain-node--self {
  background: #f0fdfa;
  border-color: #99f6e4;
}

.ud-chain-node span {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #64748b;
}

.ud-chain-node strong {
  display: block;
  margin: 0.2rem 0;
  color: #0f172a;
}

.ud-chain-node em {
  font-style: normal;
  font-weight: 700;
  color: #c2410c;
}

.ud-chain-node small {
  display: block;
  color: #64748b;
}

.ud-chain-arrow {
  align-self: center;
  color: #94a3b8;
  font-size: 0.8rem;
}

.ud-upline-list {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  margin-top: 0.85rem;
}

.ud-upline-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.75rem 0.85rem;
}

.ud-upline-card__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.55rem;
}

.ud-upline-card__total {
  margin-left: auto;
  color: #c2410c;
}

.ud-upline-split {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.5rem;
  font-size: 0.78rem;
  color: #475569;
}

.ud-muted {
  margin: 0.2rem 0;
  color: #64748b;
}

@media (max-width: 1100px) {
  .ud-charts,
  .ud-stats,
  .ud-stat-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 768px) {
  .ud-charts,
  .ud-stats,
  .ud-stat-grid {
    grid-template-columns: 1fr;
  }

  .ud-bar-row {
    grid-template-columns: 70px 1fr 64px;
  }

  .ud-export {
    margin-left: 0;
  }

  .ud-upline-card__total {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/System/UplineDownlinePage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;;;IAGE,8BAA8B;EAChC;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".ud-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.ud-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.4);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n}\n\n.ud-mode-tabs {\n  display: flex;\n  gap: 0.6rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n}\n\n.ud-mode-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #334155;\n  border-radius: 999px;\n  padding: 0.55rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.ud-mode-tab--active {\n  color: #fff;\n  border-color: #0f766e;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n}\n\n.ud-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.85rem;\n  margin-bottom: 1rem;\n}\n\n.ud-stat {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.95rem 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.ud-stat span {\n  display: block;\n  font-size: 0.78rem;\n  color: #64748b;\n  margin-bottom: 0.3rem;\n}\n\n.ud-stat strong {\n  font-size: 1.35rem;\n  color: #0f172a;\n}\n\n.ud-charts {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.85rem;\n  margin-bottom: 1rem;\n}\n\n.ud-chart-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.ud-chart-card h3 {\n  margin: 0 0 0.75rem;\n  font-size: 0.88rem;\n  color: #0f172a;\n}\n\n.ud-chart-card__body {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  flex-wrap: wrap;\n}\n\n.ud-donut {\n  position: relative;\n  width: 168px;\n  height: 168px;\n  flex-shrink: 0;\n}\n\n.ud-donut__center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.ud-donut__center strong {\n  font-size: 0.95rem;\n  color: #0f172a;\n}\n\n.ud-donut__center span {\n  font-size: 0.7rem;\n  color: #64748b;\n}\n\n.ud-legend {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  font-size: 0.78rem;\n  color: #475569;\n}\n\n.ud-legend li {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.ud-legend span {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n\n.ud-legend strong {\n  margin-left: auto;\n  color: #0f172a;\n}\n\n.ud-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.ud-bar-row {\n  display: grid;\n  grid-template-columns: 88px 1fr 72px;\n  gap: 0.5rem;\n  align-items: center;\n  font-size: 0.78rem;\n}\n\n.ud-bar-row__label {\n  color: #475569;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ud-bar-row__track {\n  height: 10px;\n  background: #f1f5f9;\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.ud-bar-row__fill {\n  height: 100%;\n  border-radius: 999px;\n  min-width: 0;\n}\n\n.ud-bar-row__value {\n  text-align: right;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.ud-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.ud-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.55rem;\n  align-items: flex-end;\n  margin-bottom: 0.9rem;\n}\n\n.ud-toolbar form {\n  display: flex;\n  gap: 0.45rem;\n  flex: 1 1 280px;\n}\n\n.ud-toolbar input,\n.ud-toolbar select {\n  border: 1px solid #dbe2ea;\n  border-radius: 8px;\n  padding: 0.45rem 0.65rem;\n  font-size: 0.86rem;\n  font-family: inherit;\n}\n\n.ud-toolbar form input {\n  flex: 1;\n  min-width: 180px;\n}\n\n.ud-toolbar label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #64748b;\n}\n\n.ud-toolbar form button,\n.ud-btn-view {\n  border: none;\n  border-radius: 8px;\n  padding: 0.45rem 0.8rem;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.ud-export {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  border: none;\n  border-radius: 8px;\n  padding: 0.45rem 0.85rem;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #fff;\n  background: linear-gradient(135deg, #15803d 0%, #22c55e 100%);\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.ud-export:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.ud-toast {\n  margin: 0 0 0.75rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: 8px;\n  font-size: 0.85rem;\n}\n\n.ud-toast--success {\n  color: #166534;\n  background: rgba(22, 101, 52, 0.1);\n}\n\n.ud-toast--error {\n  color: #b91c1c;\n  background: rgba(220, 38, 38, 0.08);\n}\n\n.ud-empty {\n  text-align: center;\n  color: #64748b;\n  padding: 1.5rem 0.6rem;\n}\n\n.ud-empty i {\n  display: block;\n  font-size: 1.5rem;\n  margin-bottom: 0.45rem;\n}\n\n.ud-table-wrap {\n  overflow-x: auto;\n}\n\n.ud-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.ud-table th {\n  padding: 0.7rem 0.75rem;\n  text-align: left;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #f8fafc;\n  background: #0f172a;\n  white-space: nowrap;\n}\n\n.ud-table td {\n  padding: 0.7rem 0.75rem;\n  border-bottom: 1px solid #e2e8f0;\n  color: #1e293b;\n  vertical-align: top;\n}\n\n.ud-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.ud-user-mini {\n  display: flex;\n  flex-direction: column;\n  gap: 0.12rem;\n}\n\n.ud-user-mini strong {\n  color: #0f172a;\n}\n\n.ud-user-mini span {\n  font-size: 0.75rem;\n  color: #64748b;\n}\n\n.ud-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.12rem 0.48rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.ud-chip--ok {\n  background: rgba(13, 148, 136, 0.14);\n  color: #0f766e;\n}\n\n.ud-chip--pending {\n  background: rgba(217, 119, 6, 0.14);\n  color: #b45309;\n}\n\n.ud-chip--bad {\n  background: rgba(220, 38, 38, 0.12);\n  color: #b91c1c;\n}\n\n.ud-chip--muted {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.ud-chip--level {\n  background: rgba(15, 118, 110, 0.12);\n  color: #0f766e;\n}\n\n.ud-pagination {\n  margin-top: 0.85rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n.ud-pagination label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.ud-pagination select,\n.ud-pagination button {\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  border-radius: 8px;\n  padding: 0.35rem 0.65rem;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.ud-pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ud-pagination div {\n  display: flex;\n  gap: 0.4rem;\n}\n\n.ud-detail-head {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.7rem;\n  margin-bottom: 0.85rem;\n}\n\n.ud-detail-head h2 {\n  margin: 0;\n  font-size: 1.15rem;\n  color: #0f172a;\n}\n\n.ud-detail-head p {\n  margin: 0.2rem 0 0;\n  color: #64748b;\n  font-size: 0.85rem;\n}\n\n.ud-btn-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #0f172a;\n  border-radius: 8px;\n  padding: 0.4rem 0.75rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.ud-detail-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.55rem;\n  align-items: center;\n  margin-bottom: 0.85rem;\n  font-size: 0.85rem;\n  color: #475569;\n}\n\n.ud-help {\n  margin: 0 0 1rem;\n  padding: 0.65rem 0.8rem;\n  background: #f0fdfa;\n  border: 1px solid #99f6e4;\n  border-radius: 10px;\n  color: #0f766e;\n  font-size: 0.85rem;\n}\n\n.ud-stat-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0.7rem;\n  margin-top: 0.25rem;\n}\n\n.ud-stat-grid div {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.7rem 0.8rem;\n}\n\n.ud-stat-grid span,\n.ud-stat-grid small {\n  display: block;\n  color: #64748b;\n  font-size: 0.72rem;\n}\n\n.ud-stat-grid strong {\n  display: block;\n  margin: 0.2rem 0;\n  font-size: 1.05rem;\n  color: #0f172a;\n}\n\n.ud-block-title {\n  margin: 1.1rem 0 0.65rem;\n  font-size: 0.92rem;\n  color: #0f172a;\n}\n\n.ud-chain {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  gap: 0.45rem;\n}\n\n.ud-chain-node {\n  min-width: 140px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.65rem 0.75rem;\n}\n\n.ud-chain-node--self {\n  background: #f0fdfa;\n  border-color: #99f6e4;\n}\n\n.ud-chain-node span {\n  display: block;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.ud-chain-node strong {\n  display: block;\n  margin: 0.2rem 0;\n  color: #0f172a;\n}\n\n.ud-chain-node em {\n  font-style: normal;\n  font-weight: 700;\n  color: #c2410c;\n}\n\n.ud-chain-node small {\n  display: block;\n  color: #64748b;\n}\n\n.ud-chain-arrow {\n  align-self: center;\n  color: #94a3b8;\n  font-size: 0.8rem;\n}\n\n.ud-upline-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  margin-top: 0.85rem;\n}\n\n.ud-upline-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.75rem 0.85rem;\n}\n\n.ud-upline-card__head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n.ud-upline-card__total {\n  margin-left: auto;\n  color: #c2410c;\n}\n\n.ud-upline-split {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-top: 0.5rem;\n  font-size: 0.78rem;\n  color: #475569;\n}\n\n.ud-muted {\n  margin: 0.2rem 0;\n  color: #64748b;\n}\n\n@media (max-width: 1100px) {\n  .ud-charts,\n  .ud-stats,\n  .ud-stat-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .ud-charts,\n  .ud-stats,\n  .ud-stat-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .ud-bar-row {\n    grid-template-columns: 70px 1fr 64px;\n  }\n\n  .ud-export {\n    margin-left: 0;\n  }\n\n  .ud-upline-card__total {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
